import { API_BASE_URL } from '@/utils/config';

export interface FeedbackData {
  session_id: string;
  rating?: number;
  comment?: string;
  email?: string;
}

export async function submitFeedback(data: FeedbackData): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/api/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`Failed to submit feedback: ${response.status}`);
  }
}
